import { render, staticRenderFns } from "./LineBorderSvg.vue?vue&type=template&id=6cc3ad43"
import script from "./LineBorderSvg.vue?vue&type=script&lang=js"
export * from "./LineBorderSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports